import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {ShippingAddressesPanel} from "../../../../common/shipping-addresses-panel/shipping-addresses-panel";
import {UserAssetsLayout}       from "../common/layout/user-assets-layout";

export const AccountAdminShippingRoute = () => cs(
    ({}, next) => UserAssetsLayout({activeTab: "admin-shipping", next}),
    consumeContext("apis"),
    ["agentId", ({}, next) => next(parseUrlQuery(window.location.search)?.agent)],
    ({apis, agentId}) => ShippingAddressesPanel({
        apis: {
            getList: () => apis.next.shipping.getMyShippingAddresses({idEntity: agentId, infoFor: 'account_resources'}),
            add: ({address}) => apis.next.shipping.addShippingAddress({address, idEntity: agentId}),
            deleteShippingAddress: (id) => apis.next.shipping.deleteShippingAddress(id, {agentId}),
        },
    }),
);
